import React, { lazy, Suspense } from 'react';

const LazyApplicationIdList = lazy(() => import('./ApplicationIdList'));

const ApplicationIdList = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyApplicationIdList {...props} />
  </Suspense>
);

export default ApplicationIdList;
